import config from "config/config.js";

const checkCardNumber = (numero) => {
  const requestOptions = { method: "GET", mode: "cors" };
  return fetch(
    `${config.baseUrl}/tesseres?numero=${numero}`,
    requestOptions
    //).then(handleResponse);
  )
    .then((response) => response.json())
    .then((res) => {
      return res;
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      // console.log("Error: ", e);
      return null;
    });
};

export default checkCardNumber;
